@if (isIdle() || isLoading() || isError()) {
    <qpx-splash [isError]="isError()" />
    <div
        class="qpx-splashable loading"
        [class.qpx-bootstrap-error]="isError()"
    ></div>
} @else {
    <div
        class="layout"
        [class.desktop]="isRailOrWider()"
        [class.top-bar-shell]="topBarEligible()"
        [class.sidebar-expanded]="
            !topBarEligible() &&
            effectiveSidebarExpanded() &&
            isRailOrWider() &&
            !isCompactRail()
        "
    >
        @if (topBarEligible()) {
            <qpx-app-top-bar
                [hasUnreadReleaseNotes]="hasUnreadReleaseNotes()"
                class="app-top-bar"
                [shortcutsByScope]="topBarShortcutsByScope()"
                [manageCompanyShortcut]="manageCompanyShortcut()"
                (findBuildingRequested)="openFindBuilding($event)"
                (whatsNewRequested)="openWhatsNew()"
            />
        } @else {
            <div
                class="header"
                data-layout-header
                [class.compact]="isCompactRail()"
                [class.compact-expanded]="
                    isCompactRail() && effectiveSidebarExpanded()
                "
                (mouseleave)="onHeaderMouseLeave($event)"
            >
                <qpx-header
                    #header
                    [isExpanded]="menuExpanded()"
                    [isVisuallyExpanded]="effectiveSidebarExpanded()"
                    (toggleRequested)="onHeaderToggle()"
                />
            </div>

            <qpx-sidebar
                [hasUnreadReleaseNotes]="hasUnreadReleaseNotes()"
                #sidebar
                [isExpanded]="menuExpanded()"
                [isHoverExpanded]="sidebarHovered()"
                [extraGeneralNavItems]="extraGeneralNavItems()"
                (toggleChange)="onToggleChange($event)"
                (focusRestoreRequested)="restoreHeaderToggleFocus()"
                (hoveredChange)="onSidebarHoveredChange($event)"
                (findBuildingRequested)="openFindBuilding()"
                (whatsNewRequested)="openWhatsNew()"
            />
        }

        <div class="content">
            <section
                #routedContent
                class="routed-content"
                aria-label="Page content"
                tabindex="-1"
            >
                <router-outlet />
            </section>
        </div>

        <qpx-utility-dock
            #utilityDock
            [actions]="utilityActions()"
            [class.mobile]="!isRailOrWider()"
        />
    </div>
}
